export default __webpack_public_path__ + "static/logo-light-3e57381cf54fe73b3f1b018cb4525d21.png";